<template>
  <v-app>
    <v-main class="pa-0">
      <navbar/>
      <router-view v-if="isMounted" :key="$route.fullPath"/>
      <UniversalPopup ref="secondDialog"/>
      <UniversalPopup ref="mainDialog"/>
      <v-overlay
          v-if="globalSettings.isLoading"
          :model-value="globalSettings.isLoading"
          class="align-center justify-center"
          persistent
      >
        <div class="text-center align-center">
          <v-progress-circular
              color="primary"
              indeterminate
              size="64"
          ></v-progress-circular>
          <br>
          <br>
          <v-chip variant="elevated">
            {{ globalSettings.loadingMessage }}
          </v-chip>
        </div>
      </v-overlay>
      <!--div v-if="!loaded" class="full-page">
        <v-container class="d-flex align-center justify-center h-100">
          <Logo :loading="!loaded"/>
        </v-container>
      </div-->
      <!--Transition name="fade-intro">
        <div v-if="!loaded" class="full-page">
          <v-container class="d-flex align-center justify-center h-100">

            <svg aria-hidden="true" class="icon" focusable="false" height="1em"
                 viewBox="0 0 512 512" width="1em" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"/>
            </svg>
          </v-container>
        </div>
      </Transition-->
    </v-main>
  </v-app>
  <!--  <Logo/>-->
  <!--PathTester/-->
</template>


<!--
TODO:
  - : open
  + : known fix
  ########################################
  FILLER:
  - (neue aufgabe -> sollstart = sollende von vorheriger aufgabe) - erstmal soll die app nur lesend auf die Hauptdaten zugreifen (abgesehen von Rückmeldungen)
  - hover info überarbeiten (prio + state hat own wärend die anderen normale haben)
  - (tasks id nicht bearbeitbar und dafür hoch und runter buttons || nach zeit sortieren) - erstmal soll die app nur lesend auf die Hauptdaten zugreifen (abgesehen von Rückmeldungen)
  - timeline reaktiv machen
  + suche mit '*' kompatible machen (kb lol)
  - feedbackform überarbeiten (datum etc)
  - tabs bei tasks auf 0 setzten wenn geöffnet wird
  - hover popup
  - dynmaische listen: assetlist muss sich anpassen (lockouts hat alle normalen aufgaben in assetlist)
  - CPU alias bei motor hinzufügen
    ########################################
  DESIGN/FORM:
  - zeitplan clickable
  - Rückmeldung + Aufgabe button spacing
  + VueScheduler ändert width bei zu kleiner zeitspanne -> align left
  + löschen eines Feedbacks ist sehr unübersichtlich -> id darstellen
  - icons für textboxen https://vuetifyjs.com/en/components/textareas/#counter
  - farben tde + tdm
  - GroupSelect TDM icon hover komisch (scheduler auch)
  - mobile friendly machen
  - timeline aktuelle aufgabe outlined machen
  - allgemeine struktur (author....)!!!
  - dark mode color
  - title und assetlist horizontal centern
  ########################################
  BUGS:
  (+ aufgabe kann hinzugefügt werden und beim öffnen von zeitplan crash alles -> zeit muss angegeben sein -> Validierung!!!)
  (+ wenn man keine gruppe auswählt buggt die timeline mit einem roten feld oben -> Validierung!!!)
  - #convertAuftragToTimelineFormat sortiert reihenfolge vom auftrag um -> neuer Stand: ist mir lange nicht aufgefallen
  - neue id bei tasks
  - (aufgabe hinzufügen wird nicht gespeichert)
  - websocket timeout 'ws://192.168.178.147:8080/ws'
  - (wenn reihenfolge gleich und) sollstart unterschiedlich dann buggt die timeline (auftrag 101)
  - tasks onchange geht nicht (kp ob implimentiert)
  - report sort by progress -> crash da das feld erst beim laden initialisiert wird und vorher gefiltert -> vorher progress berechnen
    Reporting:
      -progress ist nicht wirklich reaktiv
  -Filter "=beckm" geht z.b. nicht
    ########################################
  MAIN:
  - validation - end vor start soll nicht gehen
  - aktiver auftrag system (welcher auftrag wird derzeitig ausgeführt)
  - notifications
  - aufgabenüberschneidungsüberprüfung (janzschönlängeswortlol)
  - user
  | - lazy laden optimieren
  | - autoImport bei releade deaktivieren...
  - state multi select
  - assetlist title und id suchen
  - assetlist erst id laden und lazy title laden
  - stateselect multiple ermöglichen
  - lockout path??
  - modelValue bei assetList dynamisch machen je nach dem welches feld er findet
  - initals universell so wie bei microsoft -> sso email nutzen

  -

  -order_id bei checklisten?? wäre nicht task_id besser?


aufgehört bei:
  - timeline focus bzw zuweisung passt nicht bei checklisten auftrag



-->

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import NavBar from "@/components/misc/NavBar.vue";
import OrderListAll from "@/views/orders/OrderListAll.vue";
import Test from "@/components/misc/Test.vue";
import LampEffect from "@/components/visual/LampEffect.vue";
import CloseFeedbackForm from "@/components/forms/CloseFeedbackForm.vue";
import PathTester from "@/components/misc/pathTester.vue";
import Logo from "@/components/visual/Logo.vue";
import {useGlobalSetting, useMainPopup, useSecondPopup} from "@/lib/utils";
import UniversalPopup from "@/components/misc/UniversalPopup.vue";
import {nextTick, ref} from "vue";
import FilterHelperDialog from "@/components/dialogs/FilterHelperDialog.vue";
import ChecklistFillForm from "@/components/checklists/ChecklistFillForm.vue";
import AGB from "@/components/dialogs/AGB.vue";

/*window.addEventListener('DOMContentLoaded', () => {
  const link = document.createElement('link');
  link.rel = 'icon';
  link.href = '/favicon.ico';
  document.head.appendChild(link);
});*/


@Options({
  methods: {},
  components: {
    AGB,
    ChecklistFillForm,
    FilterHelper: FilterHelperDialog,
    UniversalPopup,
    Logo,
    PathTester,
    FeedbackCloseForm: CloseFeedbackForm,
    AufgabenListe: OrderListAll,
    LampEffect,
    Test: Test,
    Navbar: NavBar,
    AuftragsListe: OrderListAll
  },
})
export default class App extends Vue {
  isMounted = false;

  agb_accepted = false;

  globalSettings = useGlobalSetting();

  globalMainPopup = useMainPopup();
  globalSecondPopup = useSecondPopup();

  mainDialog = ref<typeof UniversalPopup | null>(null);
  secondDialog = ref<typeof UniversalPopup | null>(null);

  async mounted() {
    this.isMounted = true;

    this.globalSettings.isLoading = false;
    await this.initializePopup()

    window.addEventListener('resize', () => {
      this.globalSettings.isMobile = window.innerWidth <= 900;
    });

    if (!localStorage.getItem('agb_accepted')) {
      useMainPopup().open(
          AGB,
          {

          },
          {
            contentFilled: true,
            maxWidth: 1200,
            fullscreen: useGlobalSetting().isMobile,
            persistent: true,
          }
      );
    }
  }

  async initializePopup() {
    try {
      await nextTick()

      const mainDialog = this.$refs.mainDialog as any
      const secondDialog = this.$refs.secondDialog as any

      if (mainDialog) {
        this.globalMainPopup.setPopupRef(mainDialog)
      } else {
        console.warn('⚠️ Main Dialog Referenz nicht gefunden')
      }

      if (secondDialog) {
        this.globalSecondPopup.setPopupRef(secondDialog)
      } else {
        console.warn('⚠️ Second Dialog Referenz nicht gefunden')
      }

      if (!mainDialog || !secondDialog) {
        await this.fallbackInitialization()
      }

    } catch (error) {
      console.error('❌ Fehler beim Initialisieren der Popups:', error)
    }
  }

  async fallbackInitialization(): Promise<void> {
    return new Promise<void>((resolve) => {
      setTimeout(() => {
        const mainDialog = this.$refs.mainDialog as any
        const secondDialog = this.$refs.secondDialog as any

        if (mainDialog && !this.globalMainPopup.popupRef) {
          this.globalMainPopup.setPopupRef(mainDialog)
        }

        if (secondDialog && !this.globalSecondPopup.popupRef) {
          this.globalSecondPopup.setPopupRef(secondDialog)
        }

        resolve()
      }, 100)
    })
  }
}
</script>

<!--https://brand.progroup.ag/basis-elemente/farben-->
<style>

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}


#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.v-divider {
  opacity: 1 !important;
}

.full-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.divider-visible {
  height: 2px;
  background-color: rgba(0, 0, 0, 0.3);
}

.theme--light.v-divider {
  border-color: rgba(0, 0, 0, 0.3) !important;
}


.full-page-colored {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(206, 0, 88, 0.75) !important;
}

.bg_color_pro-rot {
  background-color: rgb(206, 0, 88) !important;
}

.hover_color_pro-rot:hover {
  color: rgba(206, 0, 88) !important;
}

.color_pro-rot {
  color: rgba(206, 0, 88) !important;
}

.bg_color_pro-hellblau {
  background-color: rgb(195, 214, 238) !important;
}

.color_pro-hellblau {
  color: rgb(195, 214, 238) !important;
}

.hover_color_pro-hellblau:hover {
  color: rgb(195, 214, 238) !important;
}

.bg_color_pro-dunkelblau {
  background-color: rgb(20, 22, 137) !important;
}

.hover_color_pro-dunkelblau:hover {
  color: rgb(20, 22, 137) !important;
}

.bg_color_pro-dunkelgrau {
  background-color: rgb(167, 168, 170) !important;
}

.bg_color_pro-dunkelgrau:hover {
  color: rgb(167, 168, 170) !important;
}

.bg_color_error {
  background-color: red !important;
}

.color_error {
  color: red !important;
}

.bg_color_admin {
  background-color: #c800ff !important;
}

.bg_color_meister {
  background-color: #5eff00 !important;
}


.fade-feedback-enter-active,
.fade-feedback-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.fade-feedback-enter-from,
.fade-feedback-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.fade-intro-enter-active,
.fade-intro-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.fade-intro-enter-from,
.fade-intro-leave-to {
  opacity: 0;
  transform: scale(15);
}

/*.custom-readonly {
  pointer-events: none !important;
}*/

.fixed-action {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 10;
  padding: 10px;
}

.test12 {
  border-radius: 100px !important;
  overflow: hidden;
  box-shadow: none;
}

.link-with-icon {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}

.no-underline {
  text-decoration: none;
}

.underline-text {
  text-decoration: underline;
}

</style>
